const formatGrade = (grade: string) => {
    const parsedGrade = parseFloat(grade)
    return isNaN(parsedGrade) ? "-" : `${parsedGrade.toFixed(2)}%`
}

export { formatGrade }
